import { Component, OnInit } from '@angular/core';
import { DummyCheckboxService } from "../dummyCheckbox.service";

@Component({
    selector: 'dummy-checkbox',
    template: `
        <mat-checkbox *permissionIf="'developer.mock4all.use'" class="checkbox" [checked]="isCheck" (input)="updateIsCheck()">Dummy</mat-checkbox>
    `,
    styles: [
        `.checkbox {
            padding: 0.75rem;
        }`
    ]
})
export class DummyCheckboxComponent implements OnInit{
    public isCheck: boolean = false;

    constructor(private readonly dummyCheckboxService: DummyCheckboxService) {}

    public ngOnInit(): void {
        this.initIsCheck();
    }

    public updateIsCheck(): void {
        this.isCheck = !this.isCheck;
        this.dummyCheckboxService.isDummy = this.isCheck;
    }

    private initIsCheck(): void {
        this.isCheck = this.dummyCheckboxService.isDummy;
    }
}